<template>
    <basic-header
        pretitle="Administration"
        title="Entitlements"
        buttonText="Add Entitlement"
        buttonIconClass="fa fa-plus me-1"
        @btnClick="showModal({ component: 'addEntitlement'})"
        :buttonRoles="addEntitlementRoles"
    />
    <div class="container-fluid">
        <div class="card catalog-reveal">
            <Datatable
                tableId="entitlementTable"
                :columns="columns"
                uniqueField ="entitlement_id"
                :data="$store.state.admin.entitlements"
                @deleteRows="showDeleteEntitlements"
                :deletable="$store.getters.userRoles.isAqferAdmin"
                :compact="true"
                :selectCheckboxes="$store.getters.userRoles.isAqferAdmin"
                :detailColumn="{renderBaseUrl: (data) => `/admin/entitlements/${encodeURIComponent(data.name)}/versions/${data.version}`, renderParams: (data) => ({name: data.name, version: data.version}), name: 'Entitlement'}"
            />
        </div>
    </div>
</template>
<script>
import Datatable from '../../components/Datatable.vue';
import BasicHeader from '../../components/BasicHeader.vue';
import { mapActions } from 'vuex';
import { nameCell, versionCell, softCell } from '../../utils/catalogCells';
export default{
    name: "Entitlements",
    components:{ BasicHeader, Datatable},
    data(){
        return {
            columns:[
                { data: "name", render: nameCell },
                { data: "version", render: versionCell },
                { data: "unit", render: softCell },
                { data: "quantity"}
            ],
            addEntitlementRoles: [1]
        };
    },
    beforeMount(){
        this.$store.dispatch("admin/fetchEntitlements")
    },
    methods: {
        ...mapActions({
            showModal:"showModal"
        }),
        showDeleteEntitlements(rows){
            this.showModal({ component: "deleteEntitlements", data:rows });
        }
    }
}

</script>
<style lang="scss">
@import './catalog.scss';
</style>
